

// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging'

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
   apiKey: "AIzaSyD-GblsejBGp4HQ7FutiVTWkkVrJn_2C5Y",
   authDomain: "fast-link-bae35.firebaseapp.com",
   projectId: "fast-link-bae35",
   storageBucket: "fast-link-bae35.firebasestorage.app",
   messagingSenderId: "165180701911",
   appId: "1:165180701911:web:c5b69f4ec865ec3957c492"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// export const messaging = getMessaging(app);
export let messaging = null;

let messagingPromise = null;

function ensureMessaging() {
   if (messaging) return Promise.resolve(messaging);
   if (!messagingPromise) {
      messagingPromise = isSupported()
         .then((supported) => {
            if (supported) {
               messaging = getMessaging(app);
            } else {
               console.warn('🔕 Firebase messaging not supported in this browser.');
            }
            return messaging;
         })
         .catch(() => null);
   }
   return messagingPromise;
}

ensureMessaging();

export const requestPermission = async () => {
   const activeMessaging = await ensureMessaging();
   if (!activeMessaging || typeof Notification === 'undefined') {
      return null;
   }
   const permission = await Notification.requestPermission();
   if (permission !== 'granted') {
      console.warn('🚫 Notification permission denied.');
      return null;
   }

   try {
      const token = await getToken(activeMessaging, { vapidKey: "BHVmXFdX0ZWE89E8PnpBjmCzxkUrWtHmDd1mHYoIcPOorqzu1VbdjKm0EuUU5hVXULqtOsCdslUuEwJX-jR_r-I", })
      return token;
   } catch (error) {
      console.error("Error getting FCM token", error);
      return null;
   }
};

/** Keeps listening for foreground pushes. Returns an unsubscribe function. */
export function subscribeForegroundMessages(handler) {
   let unsubscribe = () => {};
   let cancelled = false;

   ensureMessaging().then((activeMessaging) => {
      if (cancelled || !activeMessaging) return;
      unsubscribe = onMessage(activeMessaging, handler);
   });

   return () => {
      cancelled = true;
      unsubscribe();
   };
}

export const onMessageListener = () =>
   new Promise((resolve) => {
      const stop = subscribeForegroundMessages((payload) => {
         stop();
         resolve(payload);
      });
   });





